import { buildDeserializer, buildSerializer } from "lib/serializerUtils";

export const tradingTermSerializeMap = {
  id: "id",
  billingSettingsId: "billing_settings_id",
  businessId: "business_id",
  buyerTerms: "buyer_terms",
  vendorTerms: "vendor_terms",
  saleSubTypeId: "sale_sub_type_id",
  speciesId: "species_id",
  saleType: "sale_type",
  vendorScheduleDueRule: "vendor_schedule_due_rule",
  buyerScheduleDueRule: "buyer_schedule_due_rule",
};

export const serializeTradingTerm = buildSerializer(
  tradingTermSerializeMap,
  "trading term",
);

export const deserializeTradingTerm = buildDeserializer(
  tradingTermSerializeMap,
  "trading term",
);
